module.exports = __webpack_public_path__ + "img/pos--avatar.6b18fc5a.svg";